import { Injectable } from '@angular/core';
import { DataEntryHistory } from '@osos/shared/api';
import { EntryHistoryPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases';
import { DataEntryHistoryParserV1Service } from '../../parsers';
import { ParserFactory } from '../../services';

@Injectable()
export class DataEntryHistoryFactoryService extends FactoryBase<
  DataEntryHistory,
  EntryHistoryPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: DataEntryHistoryParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(presenter: EntryHistoryPresenterModel): DataEntryHistory {
    const parser = this.getParser(DataEntryHistory, EntryHistoryPresenterModel);
    const result = parser.getDataModel(presenter);

    return result;
  }

  createPresenterModel(model: DataEntryHistory): EntryHistoryPresenterModel {
    const parser = this.getParser(DataEntryHistory, EntryHistoryPresenterModel);
    const result = parser.getPresenterModel(model);
    return result;
  }
}
